/**
 * Shared constants for policy editor components
 * Extracted from policy-attributes-editor.tsx to avoid duplication
 */

import type { AttributeCategory } from '@/types/attribute'
import type { XacmlCategory } from '@/types/policy'

/**
 * Map XACML category to attribute category type
 */
export const CATEGORY_MAP: Record<XacmlCategory, AttributeCategory> = {
  subject: 'SUBJECT',
  resource: 'RESOURCE',
  action: 'ACTION',
  environment: 'ENVIRONMENT',
}

/**
 * Map attribute category to XACML category
 */
export const CATEGORY_MAP_REVERSE: Record<AttributeCategory, XacmlCategory> = {
  SUBJECT: 'subject',
  RESOURCE: 'resource',
  ACTION: 'action',
  ENVIRONMENT: 'environment',
}

/**
 * Map attribute data type to XACML data type URI
 */
export const DATA_TYPE_TO_XACML: Record<string, string> = {
  STRING: 'http://www.w3.org/2001/XMLSchema#string',
  BOOLEAN: 'http://www.w3.org/2001/XMLSchema#boolean',
  INTEGER: 'http://www.w3.org/2001/XMLSchema#integer',
  DOUBLE: 'http://www.w3.org/2001/XMLSchema#double',
  DATE: 'http://www.w3.org/2001/XMLSchema#date',
  TIME: 'http://www.w3.org/2001/XMLSchema#time',
  DATETIME: 'http://www.w3.org/2001/XMLSchema#dateTime',
  URI: 'http://www.w3.org/2001/XMLSchema#anyURI',
  ENUM: 'http://www.w3.org/2001/XMLSchema#string',
}
